import React, { useState } from 'react';
import clsx from 'clsx';
import APDropdown from 'components/Dropdown/APDropdown';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';

export const CommentActionButton = ({ onEdit, onDelete }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [confirmIsOpen, setConfirmIsOpen] = useState(false);

  const dismiss = (e) => {
    e.stopPropagation();
    setIsOpen(false);
    setConfirmIsOpen(false);
  };

  const trigger = (
    <DropdownButton
      className={clsx('button--unstyled', 'button--options', isOpen && 'opened')}
    >
      <span className="fa fa-ellipsis-v" />
    </DropdownButton>
  );


  const renderOptions = () => {
    const editComment = (e) => {
      e.stopPropagation();
      onEdit();
      dismiss(e);
    };

    const openConfirmation = (e) => {
      e.stopPropagation();
      setConfirmIsOpen(true);
    };

    return (
      <>
        <button
          className={clsx(
            'button--unstyled',
            'button--menu',
          )}
          onClick={editComment}
        >
          Edit
        </button>
        <button
          className={clsx(
            'button--unstyled',
            'button--menu',
          )}
          onClick={openConfirmation}
        >
          Delete
        </button>
      </>
    );
  };

  const renderDeleteConfirmation = () => {
    const deleteItem = (e) => {
      e.stopPropagation();
      onDelete();
      dismiss(e);
    };

    return (
      <div
        className="comment-delete"
      >
        <div className="comment-delete__message">
          Deleting this comment will remove it <strong>permanently</strong> from this conversation.
          Any email notifications that have been sent won't be deleted.
        </div>
        <div className="comment-delete__actions">
          <button
            className="comment-delete__button comment-delete__button--cancel"
            onClick={dismiss}
          >
            Cancel
          </button>
          <button
            className="comment-delete__button comment-delete__button--delete"
            onClick={deleteItem}
          >
            Delete
          </button>
        </div>
      </div>
    );
  };

  return (
    <APDropdown
      menuClass={clsx('nc-checklist__comments--popup', confirmIsOpen && 'showing-confirmation')}
      isOpen={isOpen}
      show={() => {
        setIsOpen(true);
      }}
      dismiss={dismiss}
      triggerButton={trigger}
    >
      {confirmIsOpen ? renderDeleteConfirmation() : renderOptions()}
    </APDropdown>
  );
};
